/* global adsbygoogle */
import React, { useEffect } from "react";

const AdComponent = () => {
  useEffect(() => {
    // Safely initialize AdSense once
    if (window.adsbygoogle && typeof window.adsbygoogle.push === "function") {
      try {
        // Check if the ad has already been pushed before pushing again
        console.log("Pushing ad...");
        if (!document.querySelector(".adsbygoogle[data-ad-client]")) {
          (adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (e) {
        console.error("AdSense Error:", e);
      }
    }
  }, []);


  return (
    <div className="ad-container">

      <ins
        className="adsbygoogle"
        style={{ display: "block", width: "100%", height: "1%" }} 
        data-ad-client="ca-pub-3106711852308634"
        data-ad-slot="5127837667"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdComponent;
